export enum LeaveRoomType {
  LEAVE_ROOM = 'LEAVE_ROOM',
  LEAVE_AND_CLOSE_ROOM = 'LEAVE_AND_CLOSE_ROOM',
  LEAVE_UNJOINED_ROOM = 'LEAVE_UNJOINED_ROOM',
  LEAVE_JOIN_ANOTHER = 'LEAVE_JOIN_ANOTHER',
  LEAVE_BANNED_USER = 'LEAVE_BANNED_USER',
  CLOSE_WINDOW = 'CLOSE_WINDOW',
}
